<template>
  <div id="app">
    <navigation />
    <test-class-culture-legend />
    <test-result-details />
    <classifications-legend />
    <add-class-modal v-if="!isGuest" />
    <extend-test-modal v-if="!isGuest" />
    <LightBox v-if="!isGuest" ref="lightbox" :show-caption="true" :show-light-box="false" :show-thumbs="false"
      :close-text="'Close player (Esc)'" :closable="true" :media="media" v-on:onClosed="onClosed">
      <template v-slot:close>
        <sui-button type="button" negative icon="close icon" title="Close player (Esc)"></sui-button>
      </template>
    </LightBox>
    <sui-button style="z-index: 9999; position: absolute; top: 15px; right: 0px" v-if="!isGuest && showImage"
      type="button" v-on:click="closeLightBox" negative icon="close icon" title="Close player (Esc)"></sui-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LightBox from 'vue-it-bigger';
import Navigation from '@/components/Navigation';
import ClassificationsLegend from '@/components/tests/ClassificationsLegend';
import TestClassCultureLegend from '@/components/tests/TestClassCultureLegend';
import TestResultDetails from './components/tests/TestResultDetails';
import AddClassModal from './components/classes/AddClassModal';
import ExtendTestModal from './components/tests/ExtendTestModal';

export default {
  name: 'App',
  computed: {
    ...mapGetters({
      showImage: 'showImage',
      imageIndex: 'imageIndex',
      user: 'user',
    }),
    isGuest: {
      get() {
        return this.user && this.user.profile &&
          (this.user.profile.role === 'Guest');
      },
    },
  },
  components: {
    Navigation,
    ClassificationsLegend,
    TestClassCultureLegend,
    TestResultDetails,
    AddClassModal,
    ExtendTestModal,
    LightBox,
  },
  data() {
    return {
      media: [
        {
          type: 'video',
          sources: [
            {
              src: '/static/videos/add or remove a student.mp4',
              type: 'video/mp4',
            },
          ],
          caption: 'How to add or remove a student',
          autoplay: true,
        },
        {
          type: 'video',
          sources: [
            {
              src: '/static/videos/conducting the sociogram.mp4',
              type: 'video/mp4',
            },
          ],
          caption: 'Conducting the sociogram',
          autoplay: true,
        },
        {
          type: 'video',
          sources: [
            {
              src: '/static/videos/extending the sociogram.mp4',
              type: 'video/mp4',
            },
          ],
          caption: 'Extending the sociogram',
          autoplay: true,
        },
        {
          type: 'video',
          sources: [
            {
              src: '/static/videos/generating a link to take sociogram.mp4',
              type: 'video/mp4',
            },
          ],
          caption: 'Generating a link to take the sociogram',
          autoplay: true,
        },
        {
          type: 'video',
          sources: [
            {
              src: '/static/videos/saving class list.mp4',
              type: 'video/mp4',
            },
          ],
          caption: 'Saving a class list',
          autoplay: true,
        },
        {
          type: 'video',
          sources: [
            {
              src: '/static/videos/upload class list.mp4',
              type: 'video/mp4',
            },
          ],
          caption: 'Upload a class list',
          autoplay: true,
        },
        {
          type: 'video',
          sources: [
            {
              src: '/static/videos/How to Use Generate Report Function.mp4',
              type: 'video/mp4',
            },
          ],
          caption: 'How to Use Generate Report Function',
          autoplay: true,
        },
        {
          type: 'video',
          sources: [
            {
              src: '/static/videos/How to Use Generate Teams Button.mp4',
              type: 'video/mp4',
            },
          ],
          caption: 'How to Use Generate Teams Button',
          autoplay: true,
        },
      ],
    };
  },
  watch: {
    showImage(val) {
      if (val) {
        this.$refs.lightbox.showImage(this.imageIndex);
      }
    },
  },
  methods: {
    closeLightBox() {
      this.$refs.lightbox.closeLightBox();
    },
    onClosed() {
      this.$store.dispatch('hideImage');
    },
  },
};
</script>

<style>
ExtendTestModalAddClassModal #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue